import React, { useState, useEffect } from 'react';
import axiosInstance from '../services/axiosInstance';

export default function SecureImage({ objectKey, alt, style, onError }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!objectKey) return;
    let cancelled = false;
    let blobUrl = null;
    axiosInstance.get('/api/storage/preview', { params: { key: objectKey }, responseType: 'blob' })
      .then(res => {
        blobUrl = URL.createObjectURL(res.data);
        if (cancelled) {
          URL.revokeObjectURL(blobUrl);
        } else {
          setSrc(blobUrl);
        }
      })
      .catch(() => { if (onError) onError(); });
    return () => {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [objectKey]);

  if (!src) return null;
  return <img src={src} alt={alt || ''} style={style} onError={onError} />;
}
